/* tslint:disable */
 
/**
 * PaGu Api
 * Gutschrifterstellung API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ProcessedOrderSorting = {
    UpdatedDate: 'UpdatedDate',
    ConstructionService: 'ConstructionService'
} as const;

export type ProcessedOrderSorting = typeof ProcessedOrderSorting[keyof typeof ProcessedOrderSorting];



